(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      //this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rahua-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rahua-video-player')) {
    customElements.define(
      'rahua-video-player',
      class RahuaVideoPlayer extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.desktopVideo = this.querySelector('.js-rahua-video-desktop');
          this.mobileVideo = this.querySelector('.js-rahua-video-mobile');
          this.videos = [this.desktopVideo, this.mobileVideo].filter(Boolean);
          this.mediaQuery = window.matchMedia('(min-width: 768px)');
          this.controlPosition = this.querySelector('[data-video-control-position]');
          this.toggleButton = this.querySelector('[data-video-toggle]');
          this.playIcon = this.querySelector('[data-play-icon]');
          this.pauseIcon = this.querySelector('[data-pause-icon]');

          if (!this.desktopVideo || !this.controlPosition || !this.toggleButton) return;

          this.dataset.initialized = 'true';
          this.toggleButton.addEventListener('click', () => this.togglePlayback());
          this.videos.forEach((video) => {
            video.addEventListener('play', () => this.updateButton());
            video.addEventListener('pause', () => this.updateButton());
          });
          this.mediaQuery.addEventListener('change', () => this.handleViewportChange());
          this.updateButton();
        }

        get activeVideo() {
          if (this.mobileVideo && !this.mediaQuery.matches) return this.mobileVideo;
          return this.desktopVideo;
        }

        togglePlayback() {
          const video = this.activeVideo;

          if (video.paused) {
            video.muted = false;
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => this.updateButton());
          } else {
            video.pause();
          }
        }

        handleViewportChange() {
          const activeVideo = this.activeVideo;
          this.videos.forEach((video) => {
            if (video !== activeVideo) video.pause();
          });
          this.updateButton();
        }

        updateButton() {
          const video = this.activeVideo;
          const isPlaying = !video.paused;
          this.toggleButton.setAttribute('aria-controls', video.id);
          this.toggleButton.setAttribute('aria-pressed', String(isPlaying));
          this.controlPosition.classList.toggle('t-inset-0', !isPlaying);
          this.controlPosition.classList.toggle('t-items-center', !isPlaying);
          this.controlPosition.classList.toggle('t-justify-center', !isPlaying);
          this.controlPosition.classList.toggle('t-bottom-4', isPlaying);
          this.controlPosition.classList.toggle('t-right-4', isPlaying);
          this.toggleButton.classList.toggle('t-opacity-50', isPlaying);
          this.playIcon.classList.toggle('t-hidden', isPlaying);
          this.pauseIcon.classList.toggle('t-hidden', !isPlaying);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-banner"] && !Shopify.designMode) return;
  try {
    
// Add any necessary JavaScript here if needed in the future

  } catch(e) { console.error(e); }
})();
})();
